import React, {
  CSSProperties,
  useState,
} from 'react';
import GridLayout, {
  Layout,
} from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import {
  WidgetInstance,
} from 'mobx-store/stores/customScreens/types';
import classNames from 'classnames';
import styles from './styles.module.scss';
import {
  WidgetGridProps,
} from './types';
import Widget from './widgets';
import {
  images,
} from '../../assets/image';
import Spinner from '../../components/Spinner';
import { RequestStatus } from 'mobx-store';
import { useLocation } from 'react-router';

const MOBILE_SPACING = (number: number) => number * 8;
const COLUMN_COUNT = 24;

const widgetInstanceToLayout = (instance: WidgetInstance): Layout => ({
  h: instance.height || 0,
  w: instance.width || 0,
  x: instance.startX || 0,
  y: instance.startY || 0,
  i: instance.widgetInstanceId.toString(),
});

export const calcContainerHeight = (widgetInstances: WidgetInstance[]) => {
  let containerHeight = 0;
  
  widgetInstances.forEach((widgetInstance) => {
    const widgetBottomY = widgetInstance.startY || 0 + (widgetInstance.height ? widgetInstance.height : 0);
    containerHeight = Math.max(containerHeight, widgetBottomY);
  });
  return containerHeight;
};

const calcDefaultPaddings = (
  widgetInstance: WidgetInstance,
  containerHeight: number,
  columnCount: number,
  spacing: (number: number) => number,
): CSSProperties => {
  const defaultPaddings: CSSProperties = {
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    marginBottom: 0,
  };
  
  defaultPaddings.marginLeft = widgetInstance.startX === 0 ? spacing(1) : spacing(0.5);
  defaultPaddings.marginRight = widgetInstance.startX || 0 + (widgetInstance.width ? widgetInstance.width:  0) === columnCount
    ? spacing(1) : spacing(0.5);
  defaultPaddings.marginTop = widgetInstance.startY === 0
    ? spacing(1) : spacing(0.5);
  defaultPaddings.marginBottom = widgetInstance.startY || 0 + (widgetInstance.height ? widgetInstance.height : 0) === containerHeight
    ? spacing(1) : spacing(0.5);
  return defaultPaddings;
};

const WidgetsPreview: React.FC<WidgetGridProps> = (props) => {
  const {
    items,
    focusedItem,
    setFocusedItem,
    requestStatus,
    ...gridProps
  } = props;
  const [isResizing, setIsResizing] = useState(false);
  const [currentHeight, setCurrentHeight] = useState(0);
  const [currentWidth, setCurrentWidth] = useState(0);

  const containerHeight = calcContainerHeight(items);

  const queryParams = new URLSearchParams(useLocation().search);
  const paramLang = queryParams.get('lang');
  
  const setCurrentWidgetDimensions = (layout: any) => {
    const currentWidget = layout.find((widgetLayout: any) => focusedItem == widgetLayout.i);
    if (currentWidget) {
      setCurrentHeight(currentWidget.h);
      setCurrentWidth(currentWidget.w);
    }
  }
  
  const rtl = () => {
    if(paramLang === 'ar') {
      return styles.rtl;
    }
    return null;
  };
  return (
    <div
      className={styles.previewContainer}
    >
      <div
        className={classNames([styles.previewCard])}
      >
        {
          requestStatus !== RequestStatus.LOADING
            ? (
              <GridLayout
                margin={[0, 0]}
                onResizeStart={(layout)=>{
                  setIsResizing(true);
                  setCurrentWidgetDimensions(layout);
                }}
                onResize={(layout: any)=>{
                  setCurrentWidgetDimensions(layout);
                }}
                onResizeStop={()=>{setIsResizing(false)}}
                {...gridProps}
              >
                {
                  items.map((item) => (
                    <div
                      key={item.widgetInstanceId}
                      data-grid={widgetInstanceToLayout(item)}
                      className={classNames([styles.gridItems, rtl(),styles.widgetContainer, !!focusedItem && item.widgetInstanceId.toString() === focusedItem.toString() ? styles.focusedWidgetContainer : ''])}
                      onClick={() => setFocusedItem(item.widgetInstanceId)}
                    >
                      <Widget 
                        widget={item}
                        defaultPaddings={calcDefaultPaddings(item, containerHeight, COLUMN_COUNT, MOBILE_SPACING)}
                        setFocusedItem={(item) => setFocusedItem(item.widgetInstanceId)}
                      />
                      {
                        isResizing
                        && !!focusedItem && item.widgetInstanceId.toString() === focusedItem.toString()
                        &&
                        <div className={styles.resizeOverlay}>
                        <h2 className={styles.dimensionsText}> height: {currentHeight}</h2>
                        <h2 className={styles.dimensionsText}> width: {currentWidth}</h2>
                        </div>
                      }
                    </div>
                  ))
                }
              </GridLayout>
            )
            : (
              <div
                className={styles.indicatorContainer}
              >
                <Spinner />
              </div>
            )
        }
      </div>
      <img
        src={images.phonePreview}
        className={styles.previewFrameImage}
      />
    </div>
  );
};
export default WidgetsPreview;
